import { RemixBrowser } from "@remix-run/react";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";

// Sentry is deliberately NOT initialised here. The browser SDK receives the
// visitor's IP address, so it may only load after they opt in. See
// app/components/consent/GatedScripts.tsx.

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
